import React from 'react';
import { Box, Typography } from '@mui/material';

/** Same offsets as chart legend product hover in JTIPriceAndPromotionsView (ChartProductImage). */
export const PRODUCT_IMAGE_HOVER_OFFSET_X = 12;
export const PRODUCT_IMAGE_HOVER_OFFSET_Y = 12;

/**
 * Floating hover panel used next to chart line images and on the brand board — matches Price & Promotions.
 */
export function ProductImageHoverOverlay({ cursorPos, productImage, productName, groupProductNames }) {
  if (!cursorPos) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        left:
          cursorPos.x + PRODUCT_IMAGE_HOVER_OFFSET_X > window.innerWidth - 230
            ? cursorPos.x - 230 - PRODUCT_IMAGE_HOVER_OFFSET_X
            : cursorPos.x + PRODUCT_IMAGE_HOVER_OFFSET_X,
        top:
          cursorPos.y + PRODUCT_IMAGE_HOVER_OFFSET_Y > window.innerHeight - 140
            ? cursorPos.y - 140 - PRODUCT_IMAGE_HOVER_OFFSET_Y
            : cursorPos.y + PRODUCT_IMAGE_HOVER_OFFSET_Y,
        zIndex: 9999,
        pointerEvents: 'none',
        p: 1.5,
        maxWidth: 220,
        bgcolor: 'background.paper',
        color: 'text.primary',
        boxShadow: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          width: '100%',
          minHeight: 60,
          maxHeight: 100,
          mb: 1,
          borderRadius: 0.5,
          bgcolor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {productImage ? (
          <Box
            component="img"
            src={productImage}
            alt=""
            onError={(e) => {
              e.target.style.display = 'none';
            }}
            sx={{
              width: '100%',
              maxHeight: 100,
              objectFit: 'contain',
            }}
          />
        ) : (
          <Box sx={{ width: '100%', height: 60, bgcolor: '#ffffff' }} />
        )}
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, wordBreak: 'break-word' }}>
        {productName || 'Product'}
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {groupProductNames && groupProductNames.length > 1
          ? `Click to see ${groupProductNames.length} products`
          : 'Click to see product details'}
      </Typography>
    </Box>
  );
}
